import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ValidateErrorLookupService {
    private requiredMessage: string = 'is required';
    private messages: { [key: string]: string } =
        {
            'required': this.requiredMessage,
            'requiredNoSpace': this.requiredMessage,
            'emailInvalid': 'has an invalid email format',
            'urlInvalid': 'has an invalid url format',
            'decimalInvalid': 'has an invalid number format',           
            'telephoneInvalid': 'has an invalid telephone number format',
            'passwordNoMatch': ' and Confirm Password do not match',
            'passowrdInvalid': ' needs to have:\n At least one lowercase\n At least one uppercase\n At least one numeric\n At least one special character\n Minimum 8 characters'

        }
    constructor() { }

    getErrorMessageForValidator(validatorError: string): string {
        let message = this.messages[validatorError];
        return message ? message : 'has an invalid value';
    }
}
